export class NotificationDisplay {
    text: string
    date: string
    type: string

    constructor(text: string, type : string, date:string) {
        this.text = text
        this.type = type
        this.date = date
    }
}